import { FC } from "react"
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg"

export const FriendshipIcon: FC = () => (
  <Svg width="40.319" height="40.319" viewBox="0 0 40.319 40.319">
    <Defs>
      <ClipPath id="vexiu3xxva">
        <Path data-name="長方形 1574" fill="none" d="M0 0h40.319v40.319H0z" />
      </ClipPath>
    </Defs>
    <G data-name="グループ 2351">
      <Path data-name="長方形 1573" transform="translate(23.103 11.33)" fill="#554d56" d="M0 0h13.682v12.41H0z" />
      <G data-name="グループ 2350">
        <G data-name="グループ 2349" clipPath="url(#vexiu3xxva)">
          <Path
            data-name="パス 1010"
            d="M20.9 64.946H1.329V48.082a2.7 2.7 0 0 1 2.7-2.7h14.16a2.7 2.7 0 0 1 2.7 2.7z"
            transform="translate(-.739 -25.218)"
            fill="#b4d470"
          />
          <Path
            data-name="パス 1011"
            d="M22.7 43.129 21.064 46.1l-1.633-2.971a1.589 1.589 0 0 1-.2-.766v-2.715h3.659v2.714a1.589 1.589 0 0 1-.19.767z"
            transform="translate(-10.69 -22.034)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1012"
            d="M16.785 27.308a5.25 5.25 0 0 1-5.25-5.25v-6.046h10.5v6.046a5.25 5.25 0 0 1-5.25 5.25z"
            transform="translate(-6.41 -8.898)"
            fill="#f8cea2"
          />
          <Path
            data-name="パス 1013"
            d="M24.465 16.012v6.046a5.251 5.251 0 0 1-3.977 5.094 5.251 5.251 0 0 0 6.523-5.094v-6.046z"
            transform="translate(-11.386 -8.898)"
            fill="#f6b783"
          />
          <Path
            data-name="パス 1014"
            d="M19.04 3.557a3.411 3.411 0 0 0-3.2-2.228h-2a5.887 5.887 0 0 0-5.886 5.887v3.818l1.591-.8.586-1.352a1.24 1.24 0 0 1 1.52-.686l1.979.642a3.778 3.778 0 0 0 2.331 0l1.978-.638a1.24 1.24 0 0 1 1.52.686l.586 1.352 1.591.8V6.1a2.545 2.545 0 0 0-2.546-2.546z"
            transform="translate(-4.42 -.739)"
            fill="#ce7c4a"
          />
          <Path
            data-name="パス 1015"
            d="m17.749 47.8-1.313-.9a.955.955 0 0 0-1.238.132l-1.1 1.174a.477.477 0 0 1-.817-.415l.667-3.547a.8.8 0 0 1 .363-.529l1.612-1v1.353a1.593 1.593 0 0 0 .2.766z"
            transform="translate(-7.374 -23.736)"
            fill="#91c43a"
          />
          <Path
            data-name="パス 1016"
            d="m23.353 47.8 1.313-.905a.955.955 0 0 1 1.238.132l1.1 1.174a.477.477 0 0 0 .817-.415l-.667-3.547a.8.8 0 0 0-.363-.529l-1.612-1v1.353a1.593 1.593 0 0 1-.2.766z"
            transform="translate(-12.978 -23.736)"
            fill="#91c43a"
          />
          <Path
            data-name="パス 1017"
            d="M29.817 4.035h-.051a3.41 3.41 0 0 0-1.631-1.845 7.637 7.637 0 0 1-.881 6.947l1.411-.458a1.24 1.24 0 0 1 1.52.686l.586 1.352 1.591.8V6.581a2.546 2.546 0 0 0-2.545-2.546z"
            transform="translate(-15.146 -1.217)"
            fill="#c06b36"
          />
          <Path
            data-name="パス 1018"
            d="M7.993 25.043h.557v-3.659h-.557a1.829 1.829 0 1 0 0 3.659"
            transform="translate(-3.426 -11.884)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1019"
            d="M35.728 25.043h-.557v-3.659h.557a1.829 1.829 0 0 1 0 3.659"
            transform="translate(-19.546 -11.884)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1020"
            d="M64.946 64.946H45.377V48.082a2.7 2.7 0 0 1 2.7-2.7h14.16a2.7 2.7 0 0 1 2.7 2.7z"
            transform="translate(-25.218 -25.218)"
            fill="#ff8dbe"
          />
          <Path
            data-name="パス 1021"
            d="M80.352 45.377h-2.387a2.7 2.7 0 0 1 2.7 2.7v16.869h2.387V48.082a2.7 2.7 0 0 0-2.7-2.7"
            transform="translate(-43.328 -25.218)"
            fill="#ff5fa3"
          />
          <Path
            data-name="パス 1022"
            d="M59.938 51.343a5.973 5.973 0 0 0 5.962-5.966H53.972a5.973 5.973 0 0 0 5.966 5.966"
            transform="translate(-29.994 -25.218)"
            fill="#daede4"
          />
          <Path
            data-name="パス 1023"
            d="M64.354 42.193v-2.546H60.7v2.546h-2.073a3.9 3.9 0 0 0 7.8 0z"
            transform="translate(-32.581 -22.033)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1024"
            d="M60.833 27.308a5.25 5.25 0 0 1-5.25-5.25v-6.046h10.5v6.046a5.25 5.25 0 0 1-5.25 5.25"
            transform="translate(-30.889 -8.898)"
            fill="#f8cea2"
          />
          <Path
            data-name="パス 1025"
            d="M68.513 16.012v6.046a5.251 5.251 0 0 1-3.978 5.094 5.251 5.251 0 0 0 6.523-5.094v-6.046z"
            transform="translate(-35.865 -8.898)"
            fill="#f6b783"
          />
          <Path
            data-name="パス 1026"
            d="M63.088 3.557a3.411 3.411 0 0 0-3.2-2.228h-2A5.887 5.887 0 0 0 52 7.216v3.818l1.591-.8.288.125a5.269 5.269 0 0 0 5.371-.7l2.3-1.814v.311a2.075 2.075 0 0 0 2.075 2.075h.471l1.591.8V6.1a2.546 2.546 0 0 0-2.546-2.546z"
            transform="translate(-28.899 -.739)"
            fill="#786b78"
          />
          <Path
            data-name="パス 1027"
            d="M73.931 4.035h-.051a3.41 3.41 0 0 0-1.631-1.845 7.634 7.634 0 0 1-.827 6.867l.918-.726v.311a2.075 2.075 0 0 0 2.075 2.075h.471l1.591.8V6.581a2.546 2.546 0 0 0-2.546-2.546"
            transform="translate(-39.692 -1.217)"
            fill="#675d67"
          />
          <Path
            data-name="パス 1028"
            d="M79.776 25.043h-.557v-3.659h.557a1.829 1.829 0 0 1 0 3.659"
            transform="translate(-44.025 -11.884)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1029"
            d="M52.041 25.043h.559v-3.659h-.557a1.829 1.829 0 1 0 0 3.659"
            transform="translate(-27.905 -11.884)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1030"
            d="M43.319 83.8h-16.4l.583-2.523a2.545 2.545 0 0 1 2.48-1.972h10.27a2.545 2.545 0 0 1 2.48 1.972z"
            transform="translate(-14.962 -44.074)"
            fill="#f1923b"
          />
          <Path
            data-name="パス 1031"
            d="M56.43 81.28a2.545 2.545 0 0 0-2.48-1.972h-2.387a2.545 2.545 0 0 1 2.48 1.972l.583 2.523h2.387z"
            transform="translate(-28.655 -44.074)"
            fill="#ef821d"
          />
          <Path
            data-name="パス 1032"
            d="M43.287 78.69a1.67 1.67 0 0 1-1.67-1.67v-1.83h3.341v1.829a1.67 1.67 0 0 1-1.67 1.67"
            transform="translate(-23.128 -41.786)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1033"
            d="M39.407 63.049a4.773 4.773 0 0 1-4.773-4.773v-6.364h9.545v6.364a4.773 4.773 0 0 1-4.773 4.773"
            transform="translate(-19.247 -28.849)"
            fill="#f8cea2"
          />
          <Path
            data-name="パス 1034"
            d="M46.271 51.913v6.364a4.775 4.775 0 0 1-3.579 4.623 4.776 4.776 0 0 0 5.966-4.623v-6.364z"
            transform="translate(-23.725 -28.85)"
            fill="#f6b783"
          />
          <Path
            data-name="パス 1035"
            d="M31.569 62.257h.477v-3.182h-.477a1.591 1.591 0 1 0 0 3.182"
            transform="translate(-16.66 -32.83)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1036"
            d="M56.6 62.257h-.477v-3.182h.477a1.591 1.591 0 0 1 0 3.182"
            transform="translate(-31.188 -32.83)"
            fill="#eda46b"
          />
          <Path
            data-name="パス 1037"
            d="M43.741 48.328v-1.91a3.817 3.817 0 0 0-2.141-3.431l-.43-.21a2.649 2.649 0 0 0-2.435-1.608h-2.313a5.727 5.727 0 0 0-5.727 5.731v1.432a.8.8 0 0 0 .8.8h6.663a3.819 3.819 0 0 0 2.783-1.2l.23-.245.825 1.449h.954a.8.8 0 0 0 .791-.808z"
            transform="translate(-17.058 -22.879)"
            fill="#ce7c4a"
          />
          <Path
            data-name="パス 1038"
            d="m50.489 43.6-.43-.21a2.644 2.644 0 0 0-.9-1.116 8.942 8.942 0 0 1-2.459 7.465h.349a3.818 3.818 0 0 0 2.783-1.2l.23-.245.825 1.449h.955a.8.8 0 0 0 .8-.8v-1.909a3.819 3.819 0 0 0-2.153-3.434z"
            transform="translate(-25.951 -23.494)"
            fill="#c06b36"
          />
          <Path
            data-name="パス 1039"
            d="M39.728 26.262a.591.591 0 0 0 .59-.591v-2.806a3.3 3.3 0 0 0-2.943-3.276v-6.467a2.416 2.416 0 0 0 0-3.584V5.364a3.14 3.14 0 0 0-2.79-3.117A4.02 4.02 0 0 0 30.989 0h-2a6.485 6.485 0 0 0-6.477 6.477v3.06a2.416 2.416 0 0 0 0 3.584v4.69a3.229 3.229 0 0 0-.84-.112h-.135a.591.591 0 0 0 0 1.181h.135a2.055 2.055 0 0 1 1.892 1.249.592.592 0 0 0 .285.3l.43.209a3.248 3.248 0 0 1 1.813 2.9v1.91a.2.2 0 0 1-.2.2h-.611l-.654-1.15a.59.59 0 0 0-.943-.113l-.231.245a3.239 3.239 0 0 1-2.353 1.024h-.763l.313-.827a.591.591 0 0 0-1.1-.418l-.471 1.244h-1l.132-.349a.591.591 0 0 0-1.1-.418l-.29.767h-2.389a.2.2 0 0 1-.2-.2v-1.436a5.116 5.116 0 0 1 4.614-5.109.591.591 0 0 0-.118-1.176 6.3 6.3 0 0 0-4.034 2.035l-.123.142a1.388 1.388 0 0 0-.438-.436l-1.333-.826v-.174a5.852 5.852 0 0 0 3.391-4.723 2.419 2.419 0 0 0 1.621-4.213V5.364a3.14 3.14 0 0 0-2.79-3.117A4.02 4.02 0 0 0 11.421 0h-2a6.485 6.485 0 0 0-6.478 6.477v3.06a2.419 2.419 0 0 0 1.621 4.213 5.854 5.854 0 0 0 3.391 4.723v.174l-1.332.826a1.384 1.384 0 0 0-.134.1H3.3a3.3 3.3 0 0 0-3.3 3.3v2.806a.591.591 0 1 0 1.181 0v-2.814A2.117 2.117 0 0 1 3.3 20.75h2.624l-.6 3.192a1.06 1.06 0 0 0 .566 1.149 1.074 1.074 0 0 0 .486.118 1.06 1.06 0 0 0 .775-.339l1.1-1.174a.362.362 0 0 1 .472-.05l1.058.729v3.578a.591.591 0 0 0 1.181 0v-3.577l1.058-.729a.362.362 0 0 1 .472.051l.55.586v1.166a1.379 1.379 0 0 0 .3.863 2.179 2.179 0 0 0 1.479 3.7 5.374 5.374 0 0 0 3.079 4.276v.355h-2.875a3.122 3.122 0 0 0-3.056 2.43l-.478 2.065H5.954V28.432a.591.591 0 0 0-1.181 0v10.706H1.181V28.427a.591.591 0 0 0-1.181 0v11.3a.591.591 0 0 0 .591.59h39.137a.59.59 0 0 0 .59-.59v-11.3a.591.591 0 0 0-1.181 0v10.711h-3.591V28.432a.591.591 0 0 0-1.181 0v10.706h-5.538l-.477-2.065a3.122 3.122 0 0 0-3.056-2.43h-2.873v-.355a5.375 5.375 0 0 0 3.069-4.273 2.18 2.18 0 0 0 1.479-3.7 1.414 1.414 0 0 0 .152-.237 6.553 6.553 0 0 0 9.351-5.326h.55a2.117 2.117 0 0 1 2.114 2.114v2.806a.591.591 0 0 0 .592.59zm-3.534-6.693h-3.83v-1.1a5.854 5.854 0 0 0 3.391-4.723 2.467 2.467 0 0 0 .439-.041zm-9.5 1.181h1.425a.591.591 0 0 0 .59-.591v-1.292a5.807 5.807 0 0 0 2.478 0v1.293a.591.591 0 0 0 .59.591H33.2a3.307 3.307 0 0 1-6.508 0M22.9 11.33a1.241 1.241 0 0 1 1.2-1.239v2.477a1.241 1.241 0 0 1-1.2-1.238m2.387-.96a5.843 5.843 0 0 0 5.434-.978l1.465-1.158a2.672 2.672 0 0 0 2.42 1.854v3.071a4.659 4.659 0 1 1-9.319 0zm11.705.96a1.241 1.241 0 0 1-1.205 1.239v-2.478a1.241 1.241 0 0 1 1.203 1.239m-13.3-4.852a5.3 5.3 0 0 1 5.3-5.3h2a2.832 2.832 0 0 1 2.646 1.842.591.591 0 0 0 .554.385h.051a1.957 1.957 0 0 1 1.955 1.955v3.591a2.389 2.389 0 0 0-.443-.042h-1.03a1.486 1.486 0 0 1-1.484-1.484v-.311a.591.591 0 0 0-.957-.463l-2.3 1.815a4.671 4.671 0 0 1-4.769.619l-.287-.125a.589.589 0 0 0-.236-.049h-.557a2.431 2.431 0 0 0-.443.041zm0 11.932v-4.7a2.467 2.467 0 0 0 .439.041 5.852 5.852 0 0 0 3.391 4.723v1.1h-2.739l-.227-.111a3.227 3.227 0 0 0-.86-1.054zm-14.557.458a5.805 5.805 0 0 0 2.478 0v1.463a1 1 0 0 1-.124.482l-1.112 2.027-1.115-2.029a1 1 0 0 1-.124-.482zm7.079-6.3v-2.477a1.239 1.239 0 0 1 0 2.477M4.125 6.477a5.3 5.3 0 0 1 5.3-5.3h2a2.832 2.832 0 0 1 2.646 1.842.59.59 0 0 0 .554.385h.051a1.958 1.958 0 0 1 1.955 1.955v3.592a2.4 2.4 0 0 0-.444-.042h-.169l-.432-1A1.823 1.823 0 0 0 13.337 6.9l-1.979.642a3.164 3.164 0 0 1-1.966 0L7.413 6.9a1.823 1.823 0 0 0-2.244 1.013l-.432 1h-.169a2.393 2.393 0 0 0-.443.042zm-.8 4.852A1.241 1.241 0 0 1 4.53 10.09v2.477a1.241 1.241 0 0 1-1.201-1.237m2.387 1.829V9.623l.537-1.24a.646.646 0 0 1 .8-.359l1.978.642a4.341 4.341 0 0 0 2.7 0l1.969-.643a.646.646 0 0 1 .8.359l.537 1.24v3.538a4.659 4.659 0 1 1-9.319 0m1.678 9.729-.837.891.6-3.166a.206.206 0 0 1 .094-.136l.709-.44v.293a2.186 2.186 0 0 0 .27 1.05l.568 1.045a1.536 1.536 0 0 0-1.406.462m4.557-.462.575-1.047a2.191 2.191 0 0 0 .269-1.05v-.293l.709.44a.2.2 0 0 1 .094.136l.11.587a6.288 6.288 0 0 0-.528 1.529 1.532 1.532 0 0 0-1.229-.302zm1.958 5.41a1 1 0 0 1 .887-.994v1.988a1 1 0 0 1-.887-.994m13.29 9.5.416 1.8H12.7l.416-1.8a1.946 1.946 0 0 1 1.905-1.514h2.953a2.261 2.261 0 0 0 4.364 0h2.953a1.946 1.946 0 0 1 1.909 1.517zm-5.96-2.105a1.08 1.08 0 1 1-2.16 0v-.553a5.391 5.391 0 0 0 2.16 0zm-1.08-1.625a4.187 4.187 0 0 1-4.182-4.182v-2.588H21.1a4.424 4.424 0 0 0 2.883-1.074l.364.64v3.025a4.187 4.187 0 0 1-4.182 4.182m5.364-4.779v-1.988a1 1 0 0 1 0 1.988m4.421-3.3a5.348 5.348 0 0 1-2.671-.713v-1.053a4.485 4.485 0 0 0 7.119-3.014h.894a5.383 5.383 0 0 1-5.348 4.785z"
            fill="#545151"
          />
        </G>
      </G>
    </G>
  </Svg>
)

FriendshipIcon.displayName = "FriendshipIcon"
